import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Market, Ota } from 'frontend-utils/models';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type { Period, Rate } from 'lumen/models';

export const RATESUMMARY = 'ratesummary';

export default class Ratesummary extends Model {
  [Type] = 'ratesummary' as const;

  @belongsTo('market', { async: false, inverse: null })
  declare market: Market;

  @belongsTo('ota', { async: false, inverse: null })
  declare ota: Ota;

  @belongsTo('period', { async: false, inverse: null })
  declare period: Period;

  @belongsTo('rate', { async: false, inverse: null })
  declare rate: Rate;

  @attr('boolean') declare bestFlex: boolean;
  @attr() declare comparisonRates: unknown;
  @attr('string') declare currency: string;
  @attr('dayjs') declare extractDatetime: DayjsTransformReturn;
  @attr('number') declare maxPersons: number;
  @attr('number') declare mealtypeIncluded: number;
  @attr('number') declare membershiptype: number;
  @attr('string') declare message: string;
  @attr() declare rateChanges: unknown;
  @attr('string') declare roomName: string;
  @attr('string') declare roomType: string;
  @attr('number') declare valueAverage: number;
  @attr('number') declare valueMax: number;
  @attr('number') declare valueMedian: number;
  @attr('number') declare valueMin: number;

  modelName = RATESUMMARY;
}
